import axios from 'axios';
import packageInfo from '../../../package.json';

export const APP_VERSION = packageInfo.version;
export const TYPES = { bug: 'Алдаа', idea: 'Санал', question: 'Асуулт' };
export const STATUSES = { pending: 'Хүлээгдэж буй', sent: 'Илгээсэн', failed: 'Илгээгдээгүй' };
const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const config = () => ({ headers: { Authorization: `Bearer ${localStorage.getItem('admin_token')}` } });
export const feedbackApi = {
  context: () => axios.get(`${API}/feedback/context`, config()),
  send: body => axios.post(`${API}/feedback`, body, config()),
  list: params => axios.get(`${API}/admin/feedback`, { ...config(), params }),
  clubs: () => axios.get(`${API}/admin/feedback/clubs`, config()),
  detail: id => axios.get(`${API}/admin/feedback/${id}`, config()),
  image: id => axios.get(`${API}/admin/feedback/${id}/image`, { ...config(), responseType: 'blob' }),
  retry: id => axios.post(`${API}/admin/feedback/${id}/retry`, {}, config()),
};

export const feedbackError = error => ({
  400: 'Мэдээллээ шалгана уу. Текст 10–2000 тэмдэгт байна.',
  401: 'Дахин нэвтэрнэ үү.', 403: 'Энэ үйлдлийг хийх эрхгүй байна.',
  404: 'Энэ горимд санал хүсэлт ашиглах боломжгүй.',
  409: 'Илгээлтийн төлөв өөрчлөгдсөн. Шинэчилж шалгана уу.',
  413: 'Зураг 2MB-аас ихгүй байна.', 415: 'Зөвхөн PNG/JPG зураг зөвшөөрнө.',
  429: 'Илгээх хязгаарт хүрлээ. Дараа дахин оролдоно уу.',
}[error?.response?.status] || 'Холболтын алдаа гарлаа. Дахин оролдоно уу.');

export async function checkedImage(file) {
  if (!file || file.size > 2 * 1024 * 1024) throw new Error('Зураг 2MB-аас ихгүй байна.');
  const bytes = new Uint8Array(await file.slice(0, 8).arrayBuffer());
  if ([137, 80, 78, 71, 13, 10, 26, 10].every((n, i) => bytes[i] === n)) return 'png';
  if ([255, 216, 255].every((n, i) => bytes[i] === n)) return 'jpg';
  throw new Error('Зөвхөн PNG/JPG зураг зөвшөөрнө.');
}